export const MS_IN_DAY = 86_400_000;
